import { LoadingOverlay, Stack } from '@mantine/core'
import Order from './components/Order'
import React, { useEffect, useState } from 'react'
import { getOrders } from '../api/orderService'
import { OrderInterface } from '../typings/orderTypes'
import PageEmpty from '../components/PageEmpty'
import { getEnumByName } from '../api/dictionaryService'

export default function Orders() {
  const [orders, setOrders] = useState<OrderInterface[]>()
  const [statusMap, setStatusMap] = useState<Map<string, string>>()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    const fetchData = async () => {
      try {
        const data = await getOrders()
        setOrders(data.filter((order) => order.status.toString() === '40'))
      } catch (error) {
        console.error('Failed to fetch orders:', error)
      }
    }

    const fetchStatusMap = async () => {
      try {
        const data = await getEnumByName('com.isaac.common.enumeration.IsaacOrderStatusEnum')
        setStatusMap(data)
      } catch (error) {
        console.error('Failed to fetch status map:', error)
      }
    }

    Promise.all([fetchData(), fetchStatusMap()]).finally(() => setLoading(false))
  }, [])

  return (
    <div className={'max-w-xl m-auto'}>
      <LoadingOverlay zIndex={1000} visible={loading} overlayProps={{ radius: 'sm', blur: 2 }} />
      <Stack p={'sm'}>
        {!loading && orders?.map((order) => <Order order={order} key={order.id} statusMap={statusMap!} />)}
      </Stack>
      {!loading && orders?.length === 0 && <PageEmpty title={'暂无对应状态的订单'} image={'./empty.png'} />}
    </div>
  )
}
